<template>
    <div>
        <main v-if="mobileCheck">
            <section class="slogan">
                <div class="main-title">
                    <h1>{{ $t('enprimeur15') }}</h1>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 ga4-reg-btn"><span class="v-btn__content">{{ $t("new-home11") }}</span></nuxt-link>
                </div>
            </section>
            <div class="home-tab-container">
                <div class="why-invest-wrapper">
                    <div class="container">
                        <div class="collections-h1">{{ $t('en-primeur1') }}</div>
                        <div class="card-text card-text2">{{ $t('en-primeur2') }}</div>
                        <v-row>
                            <div>
                                <div class="how-icon primeur1">
                                    <div class="card-icon card-icon-tag"></div>
                                    <div class="card-text">{{ $t('en-primeur3') }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="how-icon primeur2">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="8" y="61.3335" width="10.6667" height="10.6667" fill="#907D4C"/>
                                            <rect x="25.7773" y="47.1113" width="10.6667" height="24.8889" fill="#907D4C"/>
                                            <rect x="43.5557" y="32.8887" width="10.6667" height="39.1111" fill="#907D4C"/>
                                            <rect x="61.333" y="8" width="10.6667" height="64" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur4') }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="how-icon primeur3">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M58.75 29.3333H55.625V23.2381C55.625 14.8267 48.625 8 40 8C31.375 8 24.375 14.8267 24.375 23.2381V29.3333H21.25C17.8125 29.3333 15 32.0762 15 35.4286V65.9048C15 69.2571 17.8125 72 21.25 72H58.75C62.1875 72 65 69.2571 65 65.9048V35.4286C65 32.0762 62.1875 29.3333 58.75 29.3333ZM40 56.7619C36.5625 56.7619 33.75 54.019 33.75 50.6667C33.75 47.3143 36.5625 44.5714 40 44.5714C43.4375 44.5714 46.25 47.3143 46.25 50.6667C46.25 54.019 43.4375 56.7619 40 56.7619ZM49.6875 29.3333H30.3125V23.2381C30.3125 18.0267 34.6562 13.7905 40 13.7905C45.3438 13.7905 49.6875 18.0267 49.6875 23.2381V29.3333Z" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur5') }}</div>
                                </div>
                            </div>
                        </v-row>
                    </div>
                </div>

                <div class="container home-collections-container">
                    <h2 v-if="popularEnWines.length" class="home-title home-title-live">
                        {{ $t('latest-offers') }}
                        <a href="/en-primeur" class="show-all-btn">{{ $t('enprimeur14') }}</a>
                    </h2>
                    <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                </div>
            </div>
            <section id="how-enprimeur">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('enprimeur04') }}</h2>
                    <div class="title-border"></div>
                    <div class="how-enprimeur-wrapper">
                        <div class="how-enprimeur-item how-enprimeur-item1">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur05') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur06') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item2">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur07') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur08') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item3">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur09') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur10') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item4">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur11') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur12') }}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="lp-register">
                <div class="container1366 padding200 padding80">
                    <div>{{ $t('enprimeur16') }}</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 ga4-reg-btn"><span class="v-btn__content">{{ $t("new-home11") }}</span></nuxt-link>
                </div>
            </section>
        </main>
        <main v-else>
            <section class="slogan">
                <div class="main-title">
                    <h1>{{ $t('enprimeur15') }}</h1>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 ga4-reg-btn"><span class="v-btn__content">{{ $t("new-home11") }}</span></nuxt-link>
                </div>
            </section>

            <section id="why-enprimeur">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('en-primeur1') }}</h2>
                    <div class="title-border"></div>
                    <div class="why-vindome-wrapper">
                        <div class="why-text">{{ $t('en-primeur2') }}</div>
                        <v-row>
                            <v-col class="col-md-4 right-half-padding">
                                <div class="how-icon">
                                    <div class="card-icon card-icon-tag"></div>
                                    <div class="card-text">{{ $t('en-primeur3') }}</div>
                                </div>
                            </v-col>
                            <v-col class="col-md-4 right-half-padding left-half-padding">
                                <div class="how-icon">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="8" y="61.3335" width="10.6667" height="10.6667" fill="#907D4C"/>
                                            <rect x="25.7773" y="47.1113" width="10.6667" height="24.8889" fill="#907D4C"/>
                                            <rect x="43.5557" y="32.8887" width="10.6667" height="39.1111" fill="#907D4C"/>
                                            <rect x="61.333" y="8" width="10.6667" height="64" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur4') }}</div>
                                </div>
                            </v-col>
                            <v-col class="col-md-4 left-half-padding">
                                <div class="how-icon">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M58.75 29.3333H55.625V23.2381C55.625 14.8267 48.625 8 40 8C31.375 8 24.375 14.8267 24.375 23.2381V29.3333H21.25C17.8125 29.3333 15 32.0762 15 35.4286V65.9048C15 69.2571 17.8125 72 21.25 72H58.75C62.1875 72 65 69.2571 65 65.9048V35.4286C65 32.0762 62.1875 29.3333 58.75 29.3333ZM40 56.7619C36.5625 56.7619 33.75 54.019 33.75 50.6667C33.75 47.3143 36.5625 44.5714 40 44.5714C43.4375 44.5714 46.25 47.3143 46.25 50.6667C46.25 54.019 43.4375 56.7619 40 56.7619ZM49.6875 29.3333H30.3125V23.2381C30.3125 18.0267 34.6562 13.7905 40 13.7905C45.3438 13.7905 49.6875 18.0267 49.6875 23.2381V29.3333Z" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur5') }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </section>

            <section id="latest-offers">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('latest-offers') }}</h2>
                    <div class="title-border"></div>
                    <div class="latest-offers-wrapper">
                        <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                        <nuxt-link :to="localePath('/trading-desk/EnPrimeur')" class="show-all-btn">{{ $t('enprimeur14') }}</nuxt-link>
                    </div>
                </div>
            </section>

            <section id="how-enprimeur">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('enprimeur04') }}</h2>
                    <div class="title-border"></div>
                    <div class="how-enprimeur-wrapper">
                        <div class="how-enprimeur-item how-enprimeur-item1">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur05') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur06') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item2">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur07') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur08') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item3">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur09') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur10') }}</div>
                        </div>
                        <div class="how-enprimeur-item how-enprimeur-item4">
                            <div class="how-enprimeur-item-title">{{ $t('enprimeur11') }}</div>
                            <div class="how-enprimeur-item-text">{{ $t('enprimeur12') }}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="lp-register">
                <div class="container1366 padding200 padding80">
                    <div>{{ $t('enprimeur16') }}</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 ga4-reg-btn"><span class="v-btn__content">{{ $t("new-home11") }}</span></nuxt-link>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import { mapGetters } from "vuex";
    import WineMarketHome from "../components/WineMarketHome";
    import HomePopularWines from "../components/home/HomePopularWines";
    import {GCommon, GMarket} from "@/store/getters";
    import {AMarket} from "@/store/actions";
    import axios from "axios";
    import 'vueperslides/dist/vueperslides.css'

    export default {
        name: 'home',
        props: {
            preselectedTab: String
        },
        validations: {
            userEmail: {
                required,
                email
            },
            userName: {
                required
            },
            notes: {
                required
            }
        },
        head: {
            title: 'En Primeur Purchase | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home page-lp-collections2'
            }
        },
        components: {
            WineMarketHome, HomePopularWines
        },
        data() {
            return {
                show: false,
                showContactUs: false,
                appStore: false,
                googlePlay: false,
                popularWines: [],
                popularEnWines: [],
                selectedTab: 3,
                successMessage: false,
                successMessageEn: false,
                errorMsg: '',
                errorMsg2: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'
                },
                userEmail: '',
                userName: '',
                notes: ''
            }
        },
        computed: {
            ...mapGetters({
                topWines: GMarket.GET_TOP_WINES,
                topEnWines: GMarket.GET_TOP_EN_WINES,
                wineItems: GMarket.GET_WINES,
                mobileCheck: GCommon.GET_MOBILE_VERSION
            }),
            popularWinesIds() {
                let _list = [];
                this.topWines.forEach(el => {
                    _list.push(el.wineId + 'zzz' + el.caseSizeId)
                });
                return _list
            },
            popularEnWinesIds() {
                let _list = [];
                this.topEnWines.forEach(el => {
                    _list.push(el.wineId)
                });
                return _list
            }
        },
        methods: {
            async sendContact () {
                if (this.userEmail && this.userName && this.notes && !this.$v.userEmail.$invalid) {
                    this.errorMsg2 = '';
                    let contactCtrl = this;
                    let options = {
                        method: 'POST',
                        url: 'https://forms.raketa.cloud/submit/uVBlbFIcwV',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json;charset=UTF-8'
                        },
                        data: {
                            data: {
                                name: this.userName,
                                email: this.userEmail,
                                message: this.notes
                            }
                        }
                    };
                    let response = await axios(options);
                    let responseOK = response && response.status === 200 && response.statusText === 'OK';
                    if (responseOK) {
                        contactCtrl.successMessage = true
                    }
                } else {
                    this.errorMsg2 = 'Please fill all fields';
                }
            },
            resetForm () {
                this.userName = '';
                this.userEmail = '';
                this.notes = '';
                this.successMessage = false;
                this.showContactUs = false
            }
        },
        created (){
            this.$store.dispatch(AMarket.GET_TOP_WINES);

            this.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
                let homeCtrl = this,
                    addedWines = 0;

                if (this.wineItems.length) {
                    this.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                            homeCtrl.popularEnWines.push(wine)
                            addedWines++
                        }
                    })
                } else {
                    setTimeout(() => {
                        this.wineItems.forEach(wine => {
                            if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                                homeCtrl.popularEnWines.push(wine)
                                addedWines++
                            }
                        })
                    }, 1000)
                }

            });

            this.$store.dispatch(AMarket.GET_HOME_WINES).then(() => {
                let homeCtrl = this;
                this.wineItems.forEach(wine => {
                    if (homeCtrl.popularWinesIds.indexOf(wine.wineId + 'zzz' + wine.caseSizeId) > -1) {
                        homeCtrl.popularWines.push(wine)
                    }
                })
            });
        }
    };
</script>

<style scoped>
    .home-section1-btn1 {
        background: #FFFFFF;
        border-radius: 8px;
        padding: 8px 16px;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        display: inline-block;
        color: #004F7F;
        margin-top: 32px;
    }
    .how-enprimeur-item {
        display: inline-block;
        width: calc((100% - 84px) / 4);
        vertical-align: top;
        padding-top: 72px;
        text-align: center;
    }
    .how-enprimeur-item1 {
        background: url("../assets/landing/en1.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item2 {
        background: url("../assets/landing/en2.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item3 {
        background: url("../assets/landing/en3.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item4 {
        background: url("../assets/landing/en4.png") no-repeat center top;
    }
    .how-enprimeur-item-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #002840;
    }
    .how-enprimeur-item-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-top: 8px;
    }
    .how-enprimeur-wrapper {
        padding-bottom: 60px;
        background: url("../assets/landing/timeline.png") no-repeat center bottom;
    }
    .iframe-container2 iframe {
        border: 0;
        width: 100%;
        height: 83px;
        margin-top: 16px;
    }
    .lp-register {
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }
    .errors-container {
        padding-left: 10px;
    }
    .why-invest-wrapper {
        background: #F6F6F6;
        padding: 30px 0;
        margin-bottom: 35px;
    }
    .collections-h1 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 40px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        margin-bottom: 35px;
    }
    .card-icon-tag {
        background: url("../assets/landing/tag-svg.svg") no-repeat center;
        background-size: 65px;
    }
    .card-icon {
        height: 80px;
        width: 80px;
        margin: 0 auto 8px;
    }
    .card-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-size: 25px;
        line-height: 30px;
        margin-bottom: 16px;
        font-weight: 700;
        color: #303030;
        text-align: center;
        text-transform: uppercase;
    }
    .card-text {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #002840;
    }
    .why-text {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #002840;
        margin-bottom: 40px;
        text-align: center;
    }
    .right-half-padding {
        padding-right: 25px;
    }
    .left-half-padding {
        padding-left: 25px;
    }
    .home {
        font-size: 14px;
        background-color: #fff;
        color: #000;
    }

    .home ul {
        padding-left: 0;
    }

    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }

    .hidden {
        display: none;
    }

    /* reset */

    body, div, dl, dt, dd, ul, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, input, textarea, p, blockquote, th, td {
        margin: 0;
        padding: 0;
    }

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    fieldset, img, abbr {
        border: 0;
    }

    address, caption, cite, code, dfn, em, strong, th, var {
        font-weight: normal;
        font-style: normal;
    }

    ul li {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    button {
        border: none;
        background: none;
    }

    button:hover {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    /* slogan section */

    .slogan {
        height: 480px;
        margin-top: 80px;
        position: relative;
        background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0) 30%), url('../assets/landing/enprimeur1.svg') no-repeat center;
        background-size: cover;
    }

    .main-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 120px auto 0;
        text-align: center;
        max-width: 966px;
    }
    .main-title h1 {
        color: #ffffff;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
    }

    /* START Top Collections */
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        margin-bottom: 24px;
        position: relative;
        text-align: center;
    }

    .show-all-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        display: block;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto;
    }

    .home-collections-container {
        max-width: 1214px;
        margin: 0 auto;
    }

    /* END Top Collections */

    .home-title-wine {
        text-align: center;
        font-weight: 400;
        font-size: 40px;
        line-height: 47px;
        margin: 24px auto 40px;
    }
    .home-title-live {
        margin-top: 50px;
    }

    .browse-market-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    .browse-market-btn-de {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 56px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    #latest-offers {
        background-color: #F7F7F7;
    }
    .latest-offers-wrapper {
        margin-top: 16px;
    }

    @media(max-width: 767px) {
        .main-title {
            margin-top: 60px;
        }
        .main-title h1 {
            padding: 0 16px;
            font-size: 22px;
            line-height: 30px;
        }
        .slogan {
            height: 320px;
        }
        .main-title {
            font-size: 22px;
            line-height: 36px;
            margin: 70px auto;
        }
        .home-title {
            font-size: 17px;
            line-height: 17px;
            font-weight: 700;
        }
        .collections-h1 {
            font-size: 22px;
        }
        .show-all-btn {
            display: none;
        }
        .browse-market-btn, .browse-market-btn-de {
            margin-bottom: 32px;
        }
        .iframe-container2 {
            width: 320px;
            margin: 16px auto 0;
        }
        .iframe-container2 iframe {
            height: 132px;
        }
        .how-enprimeur-item {
            display: block;
            width: 100%;
        }
        .how-enprimeur-item1, .how-enprimeur-item2, .how-enprimeur-item3 {
            margin-bottom: 32px;
        }
        .how-enprimeur-wrapper {
            background: transparent;
        }
        .how-icon {
            margin-top: 32px;
        }
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
    }
</style>

<style>
.page-lp-collections2 .not-logged-btn-wrapper {
    display: none;
}
.page-lp-collections2 .site-navigation-not-logged {
    position: absolute;
    right: 32px;
    top: 24px;
}
.page-lp-collections2 .site-navigation-not-logged li {
    display: none;
}
.page-lp-collections2 .site-navigation-not-logged li.lang-nav {
    display: block;
}
    .contactus-dialog {
        background: #ffffff;
    }
    .theme--light.v-card.contact-card {
        box-shadow: none;
        padding-top: 31px;
        transition: none;
        background: #fff;
    }
    .home .home-tab-container .theme--light.v-tabs .v-tabs-bar {
        display: none;
    }

    .v-slide-group__wrapper {
        max-width: 640px;
        margin: 0 auto;
    }
    .trading-desk .v-slide-group__wrapper {
        margin: 0
    }
    .home-tab-container .v-slide-group__content {
        justify-content: center;
    }
    .home-tab-container .v-tab {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        color: #000 !important;
        font-size: 16px;
        text-transform: none;
        line-height: 23px;
        letter-spacing: inherit;
    }
    .home-tab-container .v-tabs-slider-wrapper {
        height: 6px !important;
        color: #E2C477 !important;
        caret-color: #E2C477 !important;
    }

    .swiper-container {
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        height: 300px;
        width: 100%;
    }
    .show-mobile .swiper-container {
        height: 360px;
    }
    .people-notice-wrapper .swiper-container {
        height: 430px;
        margin-bottom: 50px;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box;
    }

    .swiper-container-no-flexbox .swiper-slide {
        float: left
    }

    .swiper-container-vertical>.swiper-wrapper {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box
    }

    .swiper-container-android .swiper-slide,.swiper-wrapper {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }

    .swiper-container-multirow>.swiper-wrapper {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap
    }

    .swiper-container-free-mode>.swiper-wrapper {
        transition-timing-function: ease-out;
        margin: 0 auto
    }

    .swiper-slide {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform
    }

    .swiper-invisible-blank-slide {
        visibility: hidden
    }

    .swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
        height: auto
    }

    .swiper-container-autoheight .swiper-wrapper {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        transition-property: height,-webkit-transform;
        transition-property: transform,height;
        transition-property: transform,height,-webkit-transform
    }

    .swiper-container-3d {
        -webkit-perspective: 1200px;
        perspective: 1200px
    }

    .swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d
    }

    .swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10
    }

    .swiper-container-3d .swiper-slide-shadow-left {
        background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-right {
        background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-top {
        background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-bottom {
        background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
        -ms-touch-action: pan-y;
        touch-action: pan-y
    }

    .swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
        -ms-touch-action: pan-x;
        touch-action: pan-x
    }

    .swiper-button-next,.swiper-button-prev {
        position: absolute;
        top: 50%;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-size: 27px 44px;
        background-position: 50%;
        background-repeat: no-repeat
    }

    .swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
        opacity: .35;
        cursor: auto;
        pointer-events: none
    }

    .swiper-button-prev,.swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
        left: 50px;
        right: auto
    }

    .swiper-button-next,.swiper-container-rtl .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
        right: 50px;
        left: auto
    }

    .swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
    }

    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: opacity .3s;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        z-index: 10
    }

    .swiper-pagination.swiper-pagination-hidden {
        opacity: 0
    }

    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 10px;
        left: 0;
        width: 100%
    }

    .carousel-wrapper {
        height: 480px;
        position: relative;
    }

    @media (max-width: 767px) {
        .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
            bottom: 0;
        }
    }

    .swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        -webkit-transform: scale(.33);
        transform: scale(.33);
        position: relative
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
        background: #000;
        opacity: .2
    }

    button.swiper-pagination-bullet {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none
    }

    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
        background: #007aff
    }

    .swiper-container-vertical>.swiper-pagination-bullets {
        right: 10px;
        top: 50%;
        -webkit-transform: translate3d(0,-50%,0);
        transform: translate3d(0,-50%,0)
    }

    .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 6px 0;
        display: block
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 8px
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        display: inline-block;
        transition: top .2s,-webkit-transform .2s;
        transition: transform .2s,top .2s;
        transition: transform .2s,top .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 4px
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        white-space: nowrap
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: left .2s,-webkit-transform .2s;
        transition: transform .2s,left .2s;
        transition: transform .2s,left .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: right .2s,-webkit-transform .2s;
        transition: transform .2s,right .2s;
        transition: transform .2s,right .2s,-webkit-transform .2s
    }

    .swiper-pagination-progressbar {
        background: rgba(0,0,0,.25);
        position: absolute
    }

    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        background: #007aff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: left top;
        transform-origin: left top
    }

    .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        -webkit-transform-origin: right top;
        transform-origin: right top
    }

    .swiper-container-horizontal>.swiper-pagination-progressbar {
        width: 100%;
        height: 4px;
        left: 0;
        top: 0
    }

    .swiper-container-vertical>.swiper-pagination-progressbar {
        width: 4px;
        height: 100%;
        left: 0;
        top: 0
    }

    .swiper-pagination-white .swiper-pagination-bullet-active {
        background: #fff
    }

    .swiper-pagination-progressbar.swiper-pagination-white {
        background: hsla(0,0%,100%,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
        background: #fff
    }

    .swiper-pagination-black .swiper-pagination-bullet-active {
        background: #000
    }

    .swiper-pagination-progressbar.swiper-pagination-black {
        background: rgba(0,0,0,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
        background: #000
    }

    .swiper-scrollbar {
        border-radius: 10px;
        position: relative;
        -ms-touch-action: none;
        background: rgba(0,0,0,.1)
    }

    .swiper-container-horizontal>.swiper-scrollbar {
        position: absolute;
        left: 1%;
        bottom: 3px;
        z-index: 50;
        height: 5px;
        width: 98%
    }

    .swiper-container-vertical>.swiper-scrollbar {
        position: absolute;
        right: 3px;
        top: 1%;
        z-index: 50;
        width: 5px;
        height: 98%
    }

    .swiper-scrollbar-drag {
        height: 100%;
        width: 100%;
        position: relative;
        background: rgba(0,0,0,.5);
        border-radius: 10px;
        left: 0;
        top: 0
    }

    .swiper-scrollbar-cursor-drag {
        cursor: move
    }

    .swiper-zoom-container {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center
    }

    .swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
        max-width: 100%;
        max-height: 100%;
        -o-object-fit: contain;
        object-fit: contain
    }

    .swiper-slide-zoomed {
        cursor: move
    }

    .swiper-lazy-preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        -webkit-transform-origin: 50%;
        transform-origin: 50%;
        -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
        animation: swiper-preloader-spin 1s steps(12) infinite
    }

    .swiper-lazy-preloader:after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
        background-position: 50%;
        background-size: 100%;
        background-repeat: no-repeat
    }

    .swiper-lazy-preloader-white:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
    }

    @-webkit-keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    .swiper-container .swiper-notification {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        opacity: 0;
        z-index: -1000
    }

    .swiper-container-fade.swiper-container-free-mode .swiper-slide {
        transition-timing-function: ease-out
    }

    .swiper-container-fade .swiper-slide {
        pointer-events: none;
        transition-property: opacity
    }

    .swiper-container-fade .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube {
        overflow: visible
    }

    .swiper-container-cube .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1;
        visibility: hidden;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        width: 100%;
        height: 100%
    }

    .swiper-container-cube .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-cube.swiper-container-rtl .swiper-slide {
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
        pointer-events: auto;
        visibility: visible
    }

    .swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-cube .swiper-cube-shadow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .6;
        -webkit-filter: blur(50px);
        filter: blur(50px);
        z-index: 0
    }

    .swiper-container-flip {
        overflow: visible
    }

    .swiper-container-flip .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1
    }

    .swiper-container-flip .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-coverflow .swiper-wrapper {
        -ms-perspective: 1200px
    }
</style>
